export default __webpack_public_path__ + "static/media/DNo.21-4.1b995614.jpg";